import { ChatRole, type ICharacter, type IConversationMessage } from "@next-platform/client-common-core";

type GetIsChatImageBlurredOptions = {
  /** The character the message speaks as. */
  readonly character: ICharacter | null | undefined;
  readonly message: IConversationMessage | null | undefined;
  readonly blurNSFW: boolean | undefined;
  readonly isAuthenticated: boolean | undefined;
};

/**
 * Whether the chat blurs a message's image. The chat reads the character's avatar flag rather than the
 * image's own: a reader who blurs NSFW sees a character's images the way they see its avatar, and a visitor
 * sees an NSFW character's images covered. A user's own message is never blurred.
 */
export default function getIsChatImageBlurred({ character, message, blurNSFW, isAuthenticated }: GetIsChatImageBlurredOptions): boolean {
  const isCharacterBlurred = Boolean((blurNSFW && character?.avatar_is_nsfw) || (!isAuthenticated && character?.is_nsfw));
  const isCharacterMessage = message?.role === ChatRole.BOT || !message?.role;
  return isCharacterBlurred && isCharacterMessage;
}
